import LoginAuth from "modules/auth/Login";
const Login = () => {
  return <LoginAuth />
};

export default Login;